module.exports = __webpack_public_path__ + "img/Toyota-2019-Sienna-2.f91103cc.png";